<!--
 * @Author:
 * @Date: 2021-10-18 11:14:24
 * @LastEditors: Please set LastEditors
 * @Description: 自研平台在线
-->
<template>
  <div class="servicer-login-page">
    <div class="box">
      <div class="iframe-box">
        <div style="display: none">{{ messageEvent }}</div>
        <div class="iframe-view">
          <iframe
            ref="iframe"
            v-if="tokenTime"
            :key="tokenTime"
            :src="`${iframeUrl}?token=${token}`"
          />
        </div>
      </div>
    </div>
    <template>
      <div
        class="hide-box"
        :style="{ width: nowSession.hide ? '0' : '570px' }"
      >
        <div
          class="hide-btn"
          @click="handleHide"
        >
          {{ nowSession.hide ? $lang("展开") : $lang("收起") }}
        </div>
        <div class="form tao-tt-form">
          <left-form
            ref="leftForm"
            noPhoneBar
            :pickUpNetworkName="pickUpNetworkName"
            :customerInfo="customerInfo"
            :channel="'5'"
            @waybillNo="getWaybillNo"
            @customerPhone="customerPhone=$event"
            @prescriptionData="prescriptionData=$event"
            @orderSourceCode="orderSourceCode=$event"
            isService
            :leftFormSessionId="defaultSessionId"
            isOrderSuggest
          />
          <PlatformOrderCreation
            v-if="['tikTok', 'tikToknixiang'].includes(customerInfo.skillGroupCode)"
            :customerInfo="customerInfo"
          />
          <PlatformOrderCreationTaoTian
            v-if="customerInfo.skillGroupCode==='taotian'"
            :customerInfo="customerInfo"
          />
          <div class="ai-reasoning-logic">
            <div class="title">录单小助手推理逻辑：</div>
            <div style="white-space: pre-line;margin-left:20px">{{ aiReasoningLogic||'--' }}</div>
          </div>
        </div>
      </div>
    </template>
    <div class="detail">
      <div class="search-box">
        <el-input
          v-model="waybillNoValue"
          maxlength="15"
          @input="handleInput"
          clearable
        />
        <el-button
          icon="el-icon-search"
          type="primary"
          @click="handleSearch"
        >{{ $lang("查询") }}</el-button>
      </div>
      <div class="detail-zindex">
        <!-- encryption :logoTitle="$lang(`WBZX`)" -->
        <detail-right-view
          ref="detailRightViewRef"
          slot="right"
          :tabs="tabList"
          :waybillNo="waybillNo"
          :customerPhone="customerPhone"
          :prescriptionData="prescriptionData"
          copyBtn
          showPackInfo
          showStepBar
          abnormalTask
          showNetInfo
          showNetLast
          allPodSwitch
          @pickUpNetworkName="pickUpNetworkName=$event"
          @looseOrderStatus="looseOrderStatus=$event"
          @sendSignImg="handleSendSignImg"
          isPickupcode
          isAppeal
          showPickupInfo
          :showCancelBtn="showCancelBtn"
        >
        <!-- <template #platformOrder>
          <PlatformOrderCreation v-if="skillGroupCode==='tikTok'" :customerInfo="customerInfo"/>
          <PlatformOrderCreationTaoTian v-else :customerInfo="customerInfo"/>
        </template> -->
        </detail-right-view>
      </div>
    </div>
  </div>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config';
import { hasPower } from '@public/utils/common';
import { ServicerLogin } from '../tiktokTable/pool.js';
import { mapGetters } from 'vuex';
import store from '@/store';
import { isEmptyObject, debounce } from '@/common/utils/tool'
import PlatformOrderCreation from './components/PlatformOrderCreation.vue';
import PlatformOrderCreationTaoTian from './components/PlatformOrderCreationTaoTian.vue'

const tabTrail = 'trail'
const tabBase = ['CallRecords', 'CustomerServiceOrder', 'immortalTrail', 'problem', 'base']
//  注释

// import LeftForm from './_component/LeftForm'
export default {
  name: 'ImService',
  // components: { LeftForm },
  components: { PlatformOrderCreation, PlatformOrderCreationTaoTian },
  data() {
    return {
      COM_HTTP: ServicerLogin,
      onlineTotal: 0,
      allQueueNum: {
        mpQueueNum: 0,
        webQueueNum: 0,
        pddQueueNum: 0,
        currentReceptionNum: 0
      },
      staffCode: '',
      tokenTime: 1,
      resetCount: 0,
      signInLoading: false,
      signOutLoading: false,

      // 录单
      waybillNo: '',
      sessionId: '',
      waybillNoValue: '',
      tabs: [
        'second',
        {
          name: 'fourth',
          label: this.$lang('问题记录列表')
        },
        'third'
      ],
      messageEvent: '',
      messageUserList: [], // 当前接待用户列表
      messageUserCode: 'DEFAULT', // 当前接待用户
      token: '',
      cacheUserlist: [],
      userListIsNull: true,
      // 当前用户数据
      nowSession: {
        hide: true,
        waybillNo: '',
        sessionId: ''
      },
      defaultSessionId: '', // 默认sessionId
      formDataCache: {}, // formData数据存储
      storageHide: {}, // 存储当前侧栏开启状态
      prescriptionData: {},
      pickUpNetworkName: '', // 面单发放网点
      customerInfo: { skillGroupCode: '' }, // 用户信息
      tabList: [tabTrail, ...tabBase],
      customerPhone: '',
      pathMap: {},
      aiReasoningLogic: '',
      orderSourceCode: '', // 订单来源编码
      looseOrderStatus: '' // 取件状态
    };
  },
  beforeMount() {
    let token = '';
    try {
      const obj = JSON.parse(
        localStorage.getItem(this.storageKey) || '{}'
      );
      if (obj.time > Date.now() - 2 * 60 * 60 * 1000) {
        token = obj.token;
      }
    } catch (err) {
      console.error(err);
    }
    if (token) {
      this.token = token;
      this.tokenTime = Date.now();
    }
    sessionStorage.removeItem('formDataCache');
  },
  watch: {
    tokenTime(val) {
      if (val) {
        let ready = false;
        clearTimeout(this.$resetIframe);
        setTimeout(() => {
          this.$resetIframe = setTimeout(() => {
            if (!ready) {
              this.$refs.iframe.onload = null;
              this.resetCount++;
              this.tokenTime = Date.now();
              this.$message.warning(
                this.$lang('会话窗口加载失败，正在尝试重新加载')
              );
            }
          }, (this.resetCount + 1) * 3000 + 2000);
          this.$refs.iframe.onload = (e) => {
            this.resetCount = 0;
            ready = true;
          };
        });
      }
    },
    'imStorage.imCatalogue': {
      deep: true,
      handler(value) {
        if (value) {
          const { sessionId, waybillNo, mobilePhone, receiverName, skillGroupCode } = value
          const refsNow = this.$refs.leftForm
          this.nowSession.hide = false
          this.waybillNoValue = this.waybillNo = waybillNo || ''
          const onlineChannelSourceCode = skillGroupCode || ''
          try {
            refsNow.getBillDetal(
              sessionId,
              waybillNo || '',
              mobilePhone || '',
              receiverName || '',
              false,
              onlineChannelSourceCode
            );
          } catch (err) {
            console.error(err);
          }
        }
      }
    },
    'imStorage.imUserList': {
      deep: true,
      handler(userList) {
        if (userList.length) {
          const list = userList
          const obj = list.find((item) => item.isSelected)
          this.customerInfo = obj || ''
          this.platformWorkHandler(obj)
          if (obj && this.sessionId !== obj.sessionId) {
            const sessionId = this.sessionId = obj.sessionId
            // 取对应的id回填
            console.log(this.imStorage.imOrderSuggestData, '999999999999999');
            this.waybillNo = obj.waybillNo || '';
            obj.hide = true
            // 设置当前录单会话信息
            this.nowSession = Object.assign(this.nowSession, obj)
            // this.nowSession.hide = this.storageHide[sessionId]
            // 获取存储的数据
            console.log(this.nowSession.hide, this.storageHide[sessionId], 'this.storageHide')
            const nowFormDataCache = JSON.parse(sessionStorage.getItem('formDataCache')) || {}

            this.$nextTick(async () => {
              const refsNow = this.$refs.leftForm
              const { formData, networkGroup = [], waybillExist = false, keywordList = [], immortalTrailList = [], addressInitData = {}, defaultGroup = 1, secondTypeList = [], firstTypeList = [], prescriptionData = {}, customerAddress = '', customerExcList = {}, problemDescriptionInnerHTML = '' } = refsNow
              // 异常信息
              // const netAbmWaybill = refsNow.$refs?.abnomalTip?.netAbmWaybill || {}
              // 默认sessionId是否和当前id不一致 存取切换之前formData
              if (this.defaultSessionId && this.defaultSessionId !== sessionId) {
                nowFormDataCache[this.defaultSessionId] = { formData, networkGroup, waybillExist, keywordList, immortalTrailList, addressInitData, defaultGroup, secondTypeList, firstTypeList, prescriptionData, customerAddress, customerExcList, problemDescriptionInnerHTML }
                console.log(nowFormDataCache, 'formData>>>>');
                // this.pathMap[this.defaultSessionId] = this.deepClone(formData.pathList || [])
                // formData.pathList = []
                sessionStorage.setItem('formDataCache', JSON.stringify(nowFormDataCache))
              }
              // 如果当前存储有值  取存储值进行渲染  否取请求详情数据
              if (nowFormDataCache[sessionId] && !isEmptyObject(nowFormDataCache[sessionId])) {
                let { formData, networkGroup = [], waybillExist = false, keywordList = [], immortalTrailList = [], addressInitData = {}, defaultGroup = 1, secondTypeList = [], firstTypeList = [], prescriptionData = {}, customerAddress = '', customerExcList = {}, problemDescriptionInnerHTML = '' } = nowFormDataCache[sessionId]
                this.nowSession.hide = this.storageHide[sessionId]
                // const pathList = this.deepClone(this.pathMap[sessionId] || [])
                // formData.pathList = pathList
                Object.assign(refsNow, { formData, networkGroup, waybillExist, keywordList, immortalTrailList, addressInitData, defaultGroup, secondTypeList, firstTypeList, customerAddress, customerExcList, problemDescriptionInnerHTML })
                // 异常信息缓存赋值
                // refsNow.$refs.abnomalTip.netAbmWaybill = netAbmWaybill || {}
                this.prescriptionData = prescriptionData
                // this.$nextTick(() => {
                //   this.nowSession.hide = this.storageHide[sessionId]
                // })
                console.log(this.nowSession.hide, this.storageHide[sessionId], 'this.storageHide')
                refsNow.getfastWordsList()
                this.waybillNo = formData.waybillNo || ''
                setTimeout(async () => {
                  try {
                    if (!([1, 2, 3].includes(formData?.reminderMode))) {
                      const { data } = await this.COM_HTTP.getSessionWorkOrderSuggestNew(sessionId)
                      const isAiReturn = data?.graySwitch && data?.aiReturnTime >= formData.timestamp
                      if (data?.waybillNo !== formData.waybillNo) return
                      if (data && (isAiReturn || !data?.graySwitch)) {
                        this.$refs.leftForm?.setOrderSuggest(data)
                      } else {
                        this.$refs.leftForm?.setOrderSuggest({ graySwitch: true, aiReturnTime: -1 })
                      }
                    } else {
                      this.$refs.leftForm?.setOrderSuggest({ graySwitch: true, aiReturnTime: -1 })
                    }
                  } catch (err) {
                    console.error(err);
                  }
                  if (refsNow && refsNow.$refs && refsNow.$refs.labelField && (typeof refsNow.$refs.labelField.write === 'function')) {
                    refsNow.$refs.labelField.write(problemDescriptionInnerHTML || '')
                    // refsNow.changeFirstType(firstTypeId, true, recSecondTypeName, recProblemDesc)
                  }
                })
              } else {
                const waybillNo = this.waybillNo
                const onlineChannelSourceCode = obj.skillGroupCode || ''
                refsNow.resetFn().then(() => {
                  if (waybillNo) {
                    refsNow.getBillDetal(
                      sessionId,
                      waybillNo,
                      '',
                      '',
                      true,
                      onlineChannelSourceCode
                    );
                  } else {
                    // 异常信息缓存赋值
                    // refsNow.$refs.abnomalTip.netAbmWaybill = {}
                  }
                })
              }
              this.defaultSessionId = sessionId
            })
          }
        } else {
          if (this.sessionId) {
            this.$nextTick(() => {
              // 获取存储的数据
              const nowFormDataCache = JSON.parse(sessionStorage.getItem('formDataCache')) || {}
              const refsNow = this.$refs.leftForm
              // 异常信息
              // const netAbmWaybill = refsNow.$refs?.abnomalTip?.netAbmWaybill || {}
              const { formData, networkGroup = [], waybillExist = false, keywordList = [], immortalTrailList = [], addressInitData = {}, defaultGroup = 1, secondTypeList = [], firstTypeList = [], prescriptionData = {}, customerAddress = '', customerExcList = {}, problemDescriptionInnerHTML = '' } = refsNow
              nowFormDataCache[this.sessionId] = { formData, networkGroup, waybillExist, keywordList, immortalTrailList, addressInitData, defaultGroup, secondTypeList, firstTypeList, prescriptionData, customerAddress, customerExcList, problemDescriptionInnerHTML }
              sessionStorage.setItem('formDataCache', JSON.stringify(nowFormDataCache))
              this.defaultSessionId = ''
              this.sessionId = ''
              refsNow.customerAddress = ''
              refsNow && refsNow.resetFn()
            })
          }
        }
      }
    },
    'imStorage.imOrderSuggestData': {
      deep: true,
      handler(newVal) {
        this.aiReasoningLogic = ''
        if (this.sessionId === newVal?.sessionId) {
          this.aiReasoningLogic = newVal?.aiReasoningLogic || ''
          this.$refs.leftForm.setOrderSuggest(newVal)
        }
      }
    },
    waybillNo(val) {
      val !== null && (this.waybillNoValue = val);
      this.$refs.iframe.contentWindow.postMessage(
        {
          type: 'waybillNo',
          waybillNo: val || ''
        },
        '*'
      );
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      imStorage: 'imStorage'
    }),
    storageKey() {
      return `ONLINE_SERVICE_TOKEN_${this.user.staffNo}`;
    },
    // 是否显示取消订单按钮
    showCancelBtn() {
      console.log('6666666666666',this.looseOrderStatus);
      // 必须是在线工作台菜单
      if (this.$route.name !== 'imService') return false;
      // orderSourceCode 必须是 D1088
      if (this.orderSourceCode !== 'D1088') return false;
      // 取件状态必须是【待取件】、【待核价】、【待揽收】
      const validStatus = [203, 206, 207];
      if (!validStatus.includes(this.looseOrderStatus)) return false;

      return true;
    },
    iframeUrl() {
      // return 'http://localhost:8001/im-service'
      let url = 'https://imweb.jtexpress.com.cn';
      if (location.hostname === 'weboutsoured.jtexpress.com.cn') {
        url = 'https://imweb.jtexpress.com.cn/im-service';
      } else if (location.hostname === 'localhost') {
        url = 'https://uat-imweb.jtexpress.com.cn/im-service';
      } else {
        url = 'https://uat-imweb.jtexpress.com.cn/im-service';
      }
      return url;
    }
  },
  methods: {
    // 紫金山-tikTok,淘天-taotian，平台建单table展示
    platformWorkHandler(item) {
      this.customerInfo = item
    },
    handleHide() {
      console.log('aaaaaaaaaaaaa')
      this.nowSession.hide = !this.nowSession.hide;
      this.storageHide[this.sessionId] = this.nowSession.hide
    },
    handleNullHide() {
      this.userListIsNull = !this.userListIsNull;
    },
    handleInput() {
      debounce(this.handleSearch, 500);
    },
    handleSearch() {
      this.waybillNo = this.waybillNoValue.replace(/\s/g, '');
      this.waybillNoValue = this.waybillNo;
      try {
        this.$refs['leftForm'].getBillDetal(
          this.userCode + ' ',
          this.waybillNo + ' '
        );
      } catch (err) {
        console.error(err);
      }
    },
    // 设置右边的form
    wsFunc(messageEvent) {
      const {
        mobilePhone,
        receiverName,
        trackNo
      } = messageEvent.data.result;
      this.messageEvent = messageEvent.data.result;
      try {
        this.$refs['leftForm'].getBillDetal(
          trackNo,
          mobilePhone,
          receiverName
        );
      } catch (err) {
        console.error(err);
      }
    },
    hasPower(type) {
      return hasPower(this.$route.name, type);
    },
    reset() {
      this.resetCount = 0;
      this.tokenTime = Date.now();
    },
    async signIn() {
      this.signInLoading = true;
      let res = {};
      try {
        res = await this.COM_HTTP.signIn();
      } catch (err) {
        this.signInLoading = false;
      }
      const { code, data, msg } = res;
      this.signInLoading = false;
      if (code === RESPONSE_CODE.SUCCESS) {
        this.token = data.token;
        this.reset();
        localStorage.setItem(
          this.storageKey,
          JSON.stringify({
            time: Date.now(),
            token: data.token
          })
        );
        this.$message.success(msg);
      } else {
        this.$message.warning(msg);
      }
    },
    // async signOut() {
    //   this.signOutLoading = true;
    //   let res = {};
    //   try {
    //     res = await this.COM_HTTP.signOut();
    //   } catch (err) {
    //     this.signOutLoading = false;
    //   }
    //   const { code, msg } = res;
    //   this.signOutLoading = false;
    //   if (code === RESPONSE_CODE.SUCCESS) {
    //     this.tokenTime = 0;
    //     this.$message.success(msg);
    //   } else {
    //     this.$message.warning(msg);
    //   }
    //   localStorage.removeItem(this.storageKey);
    // },
    getWaybillNo(waybillNo) {
      this.waybillNo = waybillNo;
    },
    // 发送签收图片到 iframe
    handleSendSignImg(imgData) {
      if (!this.$refs.iframe || !this.$refs.iframe.contentWindow) {
        this.$message.warning(this.$lang('聊天窗口未加载完成'));
        return;
      }
      this.$refs.iframe.contentWindow.postMessage({
        type: 'sendSignImg',
        images: imgData.images
      }, '*');
    }
    // getCurrentDayReceptionNum() {
    //   this.$route.name === 'imService' &&
    //     this.COM_HTTP.getCurrentDayReceptionNum().then(({ data }) => {
    //       this.staffCode = data.staffCode;
    //       this.onlineTotal = data.currentReceptionNum;
    //       this.allQueueNum = data;
    //     });
    // }
  },
  created() {
    // this.getCurrentDayReceptionNum();
    // this.interval = setInterval(() => {
    //   this.getCurrentDayReceptionNum();
    // }, 10000);
    this.token = store.getters.token;
  },
  // beforeDestroy() {
  //   clearInterval(this.interval);
  // },
  destroyed() {
    // this.$bus.$off('setCustomerPhoneIM')
  }
};
</script>

<style lang="scss" scoped>
.servicer-login-page {
  display: flex;
  min-width: 1800px;
  align-items: stretch;
  height: calc(100vh - 116px);
  //background-color: #fff;
  box-sizing: border-box;
  padding: 0 8px;
  @include bg-color('main');
  .box {
    padding-top: 8px;
  }
  .total-text {
    float: right;
    margin-top: 20px;
    margin-right: 30px;
    @include text-color('routine');
    span {
      color: $-color-brand;
    }
  }
  .hide-box {
    width: 570px;
    margin-left: 10px;
    position: relative;
    transition: width 0.5s;

    .hide-btn {
      position: absolute;
      right: -10px;
      top: 50%;
      z-index: 1001;
      margin-top: -116px;
      //@include base-bg-color-1();
      //@include base-color('clr');
      width: 16px;
      padding: 100px 5px;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      @include text-color('routine');
      cursor: pointer;
      font-weight: bolder;
    }
  }
  .form {
    width: 540px;
    transition: width 0.5s;
    height: calc(100vh - 200px);
    // border-left: 1px solid #eee;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 70px 10px 20px;
  }
  .tao-tt-form {
    padding: 30px 10px 20px;
    &>div {
      border: 1px solid #DCDEE1;
      border-radius: 10px;
      padding: 20px 10px;
      width: 97% !important;
      ::v-deep .label {
        font-size: 12px !important;
      }
      margin-bottom: 10px;
    }
    .ai-reasoning-logic {
      line-height: 20px;
      font-size: 13px;
      padding: 10px 10px;
      .title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  .detail {
    flex: 1;
    // border-left: 1px solid #eee;
    overflow-y: auto;
    margin-left: 10px;
    position: relative;
    @include bg-color('light');

    .detail-zindex {
      overflow-y: auto;
      overflow: hidden;
      position: absolute;
      top: 65px;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 20;
      //background-color: #fff;
      @include bg-color('light');
    }
    .search-box {
      padding-top: 25px;
      height: 33px;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 20;
      @include bg-color('light');
    }
  }
  .iframe-box {
    height: 100%;
    box-sizing: border-box;
    padding-top: 70px;
    margin-top: -50px;
    padding-right: 10px;
    .iframe-view {
      width: 845px;
      height: 100%;
      border: 1px solid #DCDEE1;
      @include border-color('lighter');
      border-radius: 10px;
    }
    iframe {
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
}
</style>

<style lang="scss">
.servicer-login-page {
  .search-box {
    .el-input {
      width: 200px;
      margin-right: 10px;
    }
  }
}
</style>
